import Text from '../../../common/component/Text';

interface IProps {
  className?: string;
  title: string;
}

export default function GridModuleTitleV4({className, title}: IProps) {
  return (
    <Text
      className={cn(
        'ml-7 s16-bold-white leading-18 light:text-black',
        className
      )}
    >
      {title}
    </Text>
  );
}
